import { GlobalPartnerTypes } from '../../models/globalPartnerTypes'

export const GLOBAL_PARTNER_TYPE_OPTIONS = [
  GlobalPartnerTypes.Distributor,
  GlobalPartnerTypes.Commercial,
  GlobalPartnerTypes.Retailer,
]
